import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDmAoRsNPHiA1LveYfXGOnOrENcX9yK2T4",
  authDomain: "peters-help-desk.firebaseapp.com",
  projectId: "peters-help-desk",
  storageBucket: "peters-help-desk.appspot.com",
  messagingSenderId: "839940266279",
  appId: "1:839940266279:web:8b55e47116f6303f063102",
  measurementId: "G-ZCPFG50REK",
};

const app = initializeApp(firebaseConfig);

// ✅ Only enable App Check outside dev (so localhost stops getting spammed / blocked)
let appCheck = null;

if (process.env.NODE_ENV === "production") {
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider("6Le0Tv0rAAAAAE4S8OfmHdUNG9rMxmCUJS5LGAGb"),
    isTokenAutoRefreshEnabled: true,
  });
}

// Normal Firebase services
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, "europe-west2");

export { app, db, storage, functions, appCheck };
